import classNames from "classnames";
import { useState } from "react";
import AscButton from "../AscButton/AscButton";
import AscChallengeTopListModal from "../AscChallengeTopListModal/AscChallengeTopListModal";
import { ChallengeTopListBannerIllustration } from "../AscIllustrations";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import styles from "./AscChallengeTopListBanner.module.scss";

export interface AscFeaturedChallengeBannerProps {
  className?: string;
  title: string;
  description: string;
  challengesPath: string;
  loading?: boolean;
}

export default function AscChallengeTopListBanner({
  className,
  title,
  description,
  challengesPath,
  loading = false,
}: AscFeaturedChallengeBannerProps) {
  const [modalVisible, setModalVisible] = useState(false);

  function openModal() {
    setModalVisible(true);
  }
  return (
    <div
      data-testid="asc-challenge-top-list-banner"
      className={classNames(
        styles.ground,
        {
          [styles.loading]: loading,
        },
        className
      )}
    >
      <ChallengeTopListBannerIllustration className={styles.illustration} />
      <div className={styles.content}>
        <div className={styles.textContent}>
          <AscHeading level={3} className={styles.challengeName}>
            {title}
          </AscHeading>
          <div
            className={styles.skillName}
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </div>
        <AscButton
          onClick={openModal}
          className={styles.button}
          variant="white"
          size="large"
        >
          Learn more
        </AscButton>
      </div>
      <AscChallengeTopListModal
        visible={modalVisible}
        setVisible={setModalVisible}
        title={title}
        description={description}
        descriptionPoints={[
          "Choose a challenges",
          "Finish this challenge",
          "Get your points and coins",
        ]}
        challengesPath={challengesPath}
      />
    </div>
  );
}
